/* IronPeak lead-source reporting. One accepted GHL event per email + surface. */
(function (root) {
  'use strict';

  var GHL = 'https://services.leadconnectorhq.com/hooks/99eVuuXW11CRRtiGwcXE/webhook-trigger/5b7b3d77-8087-4f57-999f-a13bf0580e0c';
  var STORAGE_KEY = 'ip_ghl_sources';
  var ATTR_KEY = 'iph_attr';
  var ATTR_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
  var inFlight = {};

  function readAttribution (storage) {
    try { return JSON.parse(storage.getItem(ATTR_KEY) || 'null'); } catch (e) { return null; }
  }

  function captureAttribution (storage, location, document) {
    if (!storage || !location) return;
    try {
      var query = {};
      var raw = String(location.search || '').replace(/^\?/, '').split('&');
      raw.forEach(function (part) {
        var pair = part.split('=');
        var key = decodeURIComponent(pair[0] || '').toLowerCase();
        if (ATTR_FIELDS.indexOf(key) > -1) query[key] = decodeURIComponent((pair[1] || '').replace(/\+/g, ' ')).slice(0, 200);
      });
      var hasClick = Object.keys(query).length > 0;
      var stored = readAttribution(storage);
      if (!stored || (hasClick && !stored.has_click)) {
        var value = {
          ts: new Date().toISOString(),
          landing_url: String(location.href || '').slice(0, 500),
          referrer: String(document && document.referrer || '').slice(0, 500),
          has_click: hasClick
        };
        ATTR_FIELDS.forEach(function (key) { value[key] = query[key] || ''; });
        storage.setItem(ATTR_KEY, JSON.stringify(value));
      }
    } catch (e) { /* storage/query parsing must not block the page */ }
  }

  function retryDelay (response) {
    var value = response && response.headers && response.headers.get ? response.headers.get('Retry-After') : null;
    if (!value) return 600;
    var seconds = Number(value);
    var delay = isFinite(seconds) ? seconds * 1000 : Date.parse(value) - Date.now();
    return Math.max(0, Math.min(60000, isFinite(delay) ? delay : 600));
  }

  function postJson (params, attempt) {
    var fetcher = params.fetch || root.fetch;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, params.timeoutMs || 8000) : null;
    var options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params.payload)
    };
    if (controller) options.signal = controller.signal;
    var request;
    try { request = fetcher(params.url, options); } catch (error) { request = Promise.reject(error); }
    return Promise.resolve(request).then(function (response) {
      if (!response || !response.ok) {
        var error = new Error('HTTP ' + (response ? response.status : 'unknown'));
        error.status = response && response.status;
        error.retryAfter = retryDelay(response);
        throw error;
      }
      return response;
    }).then(function (response) {
      if (timer) clearTimeout(timer);
      return response;
    }, function (error) {
      if (timer) clearTimeout(timer);
      if (!attempt && (!error.status || error.status === 429 || error.status >= 500)) {
        var wait = params.wait || function (ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); };
        return wait(error.retryAfter == null ? 600 : error.retryAfter).then(function () { return postJson(params, 1); });
      }
      throw error;
    });
  }

  function readAccounts (storage) {
    try {
      var state = JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
      return state && Array.isArray(state.accounts) ? state.accounts : [];
    } catch (e) { return []; }
  }

  function readSent (storage, email) {
    var account = readAccounts(storage).find(function (item) { return item.email === email; });
    return account && Array.isArray(account.sources) ? account.sources : [];
  }

  function markSent (storage, email, source) {
    var accounts = readAccounts(storage);
    var account = accounts.find(function (item) { return item.email === email; });
    if (!account) { account = { email: email, sources: [] }; accounts.push(account); }
    if (!Array.isArray(account.sources)) account.sources = [];
    if (account.sources.indexOf(source) === -1) account.sources.push(source);
    try { storage.setItem(STORAGE_KEY, JSON.stringify({ accounts: accounts })); } catch (e) { /* retry next visit */ }
  }

  function reportSource (params) {
    params = params || {};
    var email = String(params.email || '').trim().toLowerCase();
    var source = String(params.source || '').trim();
    var storage = params.storage || root.localStorage;
    if (!email || email.indexOf('@') < 1 || !source || !storage) return Promise.resolve(false);
    captureAttribution(storage, params.location || root.location, params.document || root.document);
    if (readSent(storage, email).indexOf(source) > -1) return Promise.resolve(true);
    var key = email + '|' + source;
    if (inFlight[key]) return inFlight[key];
    var payload = {};
    var extra = params.payload || {};
    Object.keys(extra).forEach(function (name) { payload[name] = extra[name]; });
    var attribution = readAttribution(storage) || {};
    ATTR_FIELDS.concat(['landing_url', 'referrer']).forEach(function (name) {
      if (attribution[name] && !payload[name]) payload[name] = attribution[name];
    });
    if (!payload.paid_ad) {
      var medium = String(attribution.utm_medium || '').toLowerCase();
      var sourceName = String(attribution.utm_source || '').toLowerCase();
      payload.paid_ad = attribution.fbclid || attribution.gclid || medium === 'paid' || /facebook|fb|meta|instagram|ig/.test(sourceName) ? 'yes' : 'no';
    }
    payload.email = email;
    payload.source = source;
    if (params.name) payload.name = params.name;
    var request = postJson({
      url: GHL,
      payload: payload,
      fetch: params.fetch,
      wait: params.wait,
      timeoutMs: params.timeoutMs
    }).then(function () {
      markSent(storage, email, source);
      return true;
    }, function (error) {
      var warn = params.warn || function (err) {
        if (root.console && root.console.warn) root.console.warn('[IronPeak lead] GHL source event failed', {
          timestamp: new Date().toISOString(), source: source, expected: '2xx', actual: err.message
        });
      };
      warn(error, payload);
      return false;
    });
    inFlight[key] = request.then(function (result) { delete inFlight[key]; return result; });
    return inFlight[key];
  }

  captureAttribution(root.localStorage, root.location, root.document);
  root.IPLeadCapture = { postJson: postJson, reportSource: reportSource };
})(typeof globalThis !== 'undefined' ? globalThis : this);
